import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import SwiperCore, {
  Swiper,
  SwiperOptions,
  Pagination,
  Autoplay,
  Navigation,
} from 'swiper';
import { ArticleService } from 'src/app/@core/services/article.service';
import { ChannelService } from 'src/app/@core/services/channel.service';
import { PagesService } from 'src/app/@core/services/pages.service';
import { BlogService } from 'src/app/@core/services/blog.service';
import { AdsService } from 'src/app/@core/services/ads.service';

SwiperCore.use([Pagination, Autoplay, Navigation]);

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss'],
})
export class ArticlesComponent implements OnInit {
  config: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 0,
    pagination: { dynamicBullets: true, clickable: true },
    scrollbar: { draggable: true },
    autoplay: {
      disableOnInteraction: false,
      delay: 3500,
      pauseOnMouseEnter: true,
    },
    navigation: true,
  };

  id: any;
  pagina: any;
  fuente: any;
  orden: any;
  date1: any;
  date2: any;
  form: UntypedFormGroup;
  showLoader = false;
  limit = 100;
  pageSize = 0;
  page = 0;
  total: number;
  bannerImg: any;
  bannerCategory: string = 'home_banner';
  search: string = null;
  keywords: string[];
  startSplashOpen: boolean = true;
  blogPosts: any = [];
  articles: any = [];
  closeResult = '';
  queryParams: any = {};
  public channel;
  public currentUrl: string;
  public footerUrl: string;

  @ViewChild('container') container: ElementRef;
  @ViewChild('clr') clr: ElementRef;

  goToTop(): void {
    this.container.nativeElement.scrollIntoView(true);
  }

  goToBottom(): void {
    this.clr.nativeElement.scrollIntoView(false);
  }

  constructor(
    private route: ActivatedRoute,
    private articlesService: ArticleService,
    private router: Router,
    private channelService: ChannelService,
    private pageService: PagesService,
    private blogService: BlogService,
    private adsService: AdsService
  ) {
    this.currentUrl = this.router.url + '#container';
    this.footerUrl = this.router.url + '#footer';
  }

  ngOnInit(): void {
    this.adsService
      .getBannerByCategory(this.bannerCategory)
      .subscribe((res) => {
        const respuesta: any[] = res;
        respuesta.forEach((r) => {
          this.bannerImg = r.content.rendered;
        });
      });
    this.router.routerState.root.queryParams.subscribe((res: any) => {
      this.search = res.query;
      if (res.keywords) {
        this.keywords = res.keywords.split(',');
      }
    });
    this.route.queryParams.subscribe(async (params) => {
      this.queryParams = params;
      if (Object.entries(this.queryParams).length === 0) {
        this.getAllArticles();
        this.total = this.articles.length;
      } else {
        if (this.queryParams.channels) {
          this.channel = await this.channelService
            .getChannelbyId(this.queryParams.channels)
            .toPromise();
        }
        this.getArticlesByParams();
        this.total = this.articles.length;
      }
    });

    this.blogService.getAllPosts().subscribe((res) => {
      this.blogPosts = res;
    });
  }

  getArticlesByParams(): void {
    this.showLoader = true;
    const offset = this.page * this.limit;
    const params = {
      ...this.queryParams,
      offset,
      limit: this.limit,
    };
    this.articlesService.getArticlesByParams(params).subscribe(
      (articles) => {
        this.articles = [...this.articles, ...articles];
        this.showLoader = false;
        // this.page = this.page + 1;
      },
      (error) => {
        this.showLoader = false;
      }
    );
  }

  onScroll(): void {
    if (Object.entries(this.queryParams).length === 0) {
      this.getAllArticles();
    } else {
      this.getArticlesByParams();
    }
  }

  async onQuery(queryParams: any): Promise<void> {
    if (this.channel && !queryParams.channels) {
      queryParams.channels = this.channel.id;
    }
    const rta = await this.router.navigate(['/noticias'], {
      queryParams,
    });
    if (rta) {
      this.articles = [];
      this.page = 0;
    }
  }

  getAllArticles(): void {
    this.showLoader = true;
    const offset = this.page * this.limit;
    this.articlesService.getAllArticles(offset, this.limit).subscribe(
      (articles) => {
        this.articles = [...this.articles, ...articles];
        this.showLoader = false;
        this.page = this.page + 1;
      },
      (error) => {
        console.error(error);
        this.showLoader = false;
      }
    );
  }

  goArticle(articleId: number): void {
    let queryParams: any = {};
    if (this.queryParams?.query) {
      queryParams.query = this.queryParams?.query;
    }
    if (this.queryParams?.keywords) {
      queryParams.keywords = this.queryParams?.keywords;
    }
    this.router.navigate(['/noticias', articleId], { queryParams });
  }

  goNews(): void {
    window.location.href = 'https://tienda.elgreenpost.com';
  }

  goStore(): void {
    this.router.navigate(['noticias']);
  }

  getSrc(pageId: string): string {
    const page = this.pageService.getPage(pageId);
    return page ? page.logo : '/assets/images/loader.gif';
  }

  pageChanged(event: any): any {
    this.page = event;
  }

  onSwiper(swiper): any {
    /* console.log(swiper); */
  }
  onSlideChange(): any {
    /* console.log('slide change'); */
  }

  closeStartSplash(event: Event) {
    const element = event.target as HTMLElement;
    if (
      element.classList.contains('start-modal_content_grid_news_button') ||
      element.classList.contains('start-modal')
    ) {
      return (this.startSplashOpen = false);
    }
    return null;
  }
}
